/**
 * Marco de las pantallas de entrada: login, registro, invitaciones.
 *
 * Es la PRIMERA pantalla que ve un cliente potencial de Softfi. Tiene que verse
 * cara sin ser recargada: fondo con un degradado muy suave, la marca arriba y el
 * formulario centrado en una tarjeta.
 */

import { Outlet } from "react-router-dom";
import { Moon, Sun } from "lucide-react";
import { useTema } from "@/stores/ui";

export function AuthLayout() {
  const { tema, alternar } = useTema();

  return (
    <div className="relative flex min-h-dvh flex-col bg-bg">
      {/*
        Resplandor decorativo. `pointer-events-none` es importante: sin eso, este
        div invisible taparía los clics de los botones que quedan debajo.
      */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-80 bg-gradient-to-b from-brand-500/10 to-transparent"
      />

      <header className="relative flex items-center justify-between px-5 py-5 pt-safe">
        {/*
          Solo el nombre, sin el logo.

          El logo grande está abajo, encima del titular. Dos logos en la misma
          pantalla —uno chico arriba y uno grande en medio— no se leen como
          identidad de marca: se leen como un error de maquetación.
        */}
        <span className="text-lg font-semibold tracking-tight text-ink">Softfi</span>

        <button
          type="button"
          onClick={alternar}
          aria-label={tema === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
          className="rounded-[var(--radius-control)] p-2.5 text-muted transition-colors hover:bg-surface-hover hover:text-ink"
        >
          {tema === "dark" ? <Sun size={18} /> : <Moon size={18} />}
        </button>
      </header>

      <main className="relative flex flex-1 items-start justify-center px-4 pb-12 pt-4 sm:items-center sm:pt-0">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>

      <footer className="relative px-5 pb-6 pb-safe text-center text-xs text-faint">
        Softfi — Gestión de negocios
      </footer>
    </div>
  );
}
